import { IconProps } from "./type";

const PasskeysIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4513 14.1738C11.0994 13.2522 11.4472 12.153 11.4474 11.0263C11.4468 10.6749 11.4148 10.3324 11.3514 9.99895C11.2318 9.36905 11.172 9.05326 11.2335 8.85368C11.2941 8.6541 11.4709 8.47726 11.8246 8.12358L13.1316 6.81579V5.13158L14.8158 5.13158V3.44737L16.5 3.44737V0.5L14.9488 0.5C14.26 0.5 13.9156 0.500842 13.6057 0.628842C13.2958 0.756842 13.0524 1.00021 12.5657 1.48779L8.88148 5.17453C8.52695 5.52905 8.34927 5.70505 8.14969 5.76737C7.95177 5.82917 7.63956 5.77005 7.01842 5.65244L7.00274 5.64947C5.89615 5.43766 4.75115 5.57248 3.72402 6.03554C2.6969 6.4986 1.83769 7.26734 1.26367 8.23683C0.689652 9.20633 0.428789 10.3293 0.516687 11.4526C0.604584 12.5758 1.03696 13.6446 1.7548 14.513C2.47264 15.3814 3.44097 16.0071 4.52763 16.3048C5.61428 16.6024 6.76631 16.5575 7.82648 16.1761C8.88666 15.7947 9.80332 15.0955 10.4513 14.1738Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.55222 12.7106C5.88723 12.7106 6.20852 12.5776 6.44541 12.3407C6.6823 12.1038 6.81538 11.7825 6.81538 11.4475C6.81538 11.1125 6.6823 10.7912 6.44541 10.5543C6.20852 10.3174 5.88723 10.1843 5.55222 10.1843C5.21721 10.1843 4.89592 10.3174 4.65903 10.5543C4.42214 10.7912 4.28906 11.1125 4.28906 11.4475C4.28906 11.7825 4.42214 12.1038 4.65903 12.3407C4.89592 12.5776 5.21721 12.7106 5.55222 12.7106Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export default PasskeysIcon;
